import { render, staticRenderFns } from "./TwoFactorAuthenticationForm.vue?vue&type=template&id=c1608f9c&scoped=true"
import script from "./TwoFactorAuthenticationForm.vue?vue&type=script&lang=js"
export * from "./TwoFactorAuthenticationForm.vue?vue&type=script&lang=js"
import style0 from "./TwoFactorAuthenticationForm.vue?vue&type=style&index=0&id=c1608f9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1608f9c",
  null
  
)

export default component.exports